import { render, staticRenderFns } from "./EditFormSqlEditor.vue?vue&type=template&id=3ff5b5d6"
import script from "./EditFormSqlEditor.vue?vue&type=script&lang=js"
export * from "./EditFormSqlEditor.vue?vue&type=script&lang=js"
import style0 from "./EditFormSqlEditor.vue?vue&type=style&index=0&id=3ff5b5d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports